import { Injectable } from '@angular/core';
import { IAttachmentsApiClient } from './i-attachments-api.client';
import { AttachmentsApiClient } from './attachments.api.client';
import { AttachmentsInMemoryApiClient } from './attachments.api.inmemory.client';
import { ApiClientProvider } from '../../../../core';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsApiClientProvider extends ApiClientProvider<IAttachmentsApiClient> {
  constructor(
    private client: AttachmentsApiClient,
    private inMemoryClient: AttachmentsInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IAttachmentsApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IAttachmentsApiClient {
    return this.client;
  }
}
